import React from "react";
import { Redirect, useHistory, useLocation } from "react-router";

import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import UserProfile from "./components/UserProfile";
import useQueryParams from "../Shared/Hooks/useQueryParms";

import "./index.scss";

const UserProfilePage = () => {
  const history = useHistory();
  const location = useLocation();
  const { params } = useQueryParams({
    userId: {
      defaultValue: null,
    },
  });

  const localUserToken = JSON.parse(localStorage.getItem("currUserToken"));
  if (!localUserToken) return <Redirect to="/signin" />;

  const userId = params.userId;
  const authUserId = JSON.parse(localStorage.getItem("user_id"));
  const isOwnProfile = userId ? parseInt(userId) === authUserId : true;

  return (
    <div className="main-container">
      <div className="page-header">
        {!isOwnProfile && (
          <ArrowBackIcon
            className="back-icon"
            onClick={() =>
              location.key ? history.goBack() : history.push("/users")
            }
            titleAccess={location.key ? "Go Back" : "Back to User List"}
          />
        )}
        <span className="page-header-title">
          {`User Management - ${isOwnProfile ? "My Profile" : "User Profile"}`}
        </span>
      </div>
      <div className="user-profile-container">
        <UserProfile
          userId={isOwnProfile ? authUserId : userId}
          isOwnProfile={isOwnProfile}
          canUnregisterFacematch={!isOwnProfile}
        />
      </div>
    </div>
  );
};

export default UserProfilePage;
